const FormConfig = {

	selectors: {
		slides: '.configurationSlide',
		nextSlideButton: '#nextSlide',
		errorList: '.errorList',
		configurationSummary: '#configurationSummary',
		productSelectionSlide: '#product-selection-slide',
		kiSlide: '#ki-value-slide',
		fkSlide: '#fk-value-slide',

		infiltrationType: '.infiltrationType',
		rigoleOnly: '.rigoleOnly',
		retentionOnly: '.retentionOnly',
		rainwaterUtilisationOnly: '.rainwaterUtilisationOnly',
		country: '.country',
		propertyType: '.propertyType',
		weatherStation: '#weatherStation',

		configurationForm: '#configurationForm',
		rcIndexInput: '#rcIndexValue',
		rcIndexOutput: '#currentRcIndex',
		originalGridIndexInput: '#originalGridIndexValue',
		regionInput: '#regionValue',
		customRunoffValueInput: '#customRunoffValue',
		customRunoffValueIndexNotation: '#customRunoffValueIndexNotation',
		customRunoffValueSignificand: '#customRunoffValueSignificand',
		customRunoffValueExponent: '#customRunoffValueExponent',
		runoffValueIndexNotationResult: '#runoffValueIndexNotationResult',
		kiIndexNotationResult: '#kiIndexNotationResult',
		addAreaTypeButton: '#addAreaType',
		addAreaTypeLimitReached: '#addAreaTypeLimitReached',
		removeAreaTypeButton: '.removeAreaType',
		areaTypeBlock: '.areaTypeBlock',
		// DWA-A 138-1 selectors
		addAreaType1381Button: '#addAreaType1381',
		addAreaType1381LimitReached: '#addAreaType1381LimitReached',
		areacategorizationInput: '.areacategorization',
		areaCategorizationDisplayToggle: '.areacategorization-display',
		areacategorizationSelection: '.areacategorization-selection',
		areacategorizationRow: '.areacategorization-row',
		loadCategory: '.load-category',
		removeAreaType1381Button: '.removeAreaType1381',
		areaTypeBlock1381: '.areaTypeBlock1381',
		surfaceCategory1381: '.surfaceCategory1381',
		surfaceType1381Select: '.surfaceType1381Select',
		surfaceType1381Input: '.surfaceType1381Input',
		cm1381: '.cm1381',
		cs1381: '.cs1381',
		areaTypeSelect: '.roofType',
		runofftypeSelect: '.runoffType',
		runofftypeValue: '.runoffTypeValue',
		coefficientSelect: '.coefficient',
		coefficientValue: '.coefficientValue',
		areaInput: '.area',
		cityInput: '#city',
		citySelect: '#citySelect',
		resilienceRadio: '.resilience',
		productCheckbox: '.products',
		retentionProductCheckbox: '.retentionProducts',
		assignedTeamSelect: '#assignedTeam',
		processorSelect: '#processor',
		weatherStationCheckLoading: '#weatherStationCheckLoading',
		rainwaterMapLoading: '#rainwaterMapLoading',
		weatherStationCheckResult: '#weatherStationCheckResult',
		weatherstationMapResult: '#weatherstationMapResult',
		manualWeatherStationSelection: '.manualWeatherStationSelection',
		propertyStreetInput: '#street',
		propertyZipInput: '#propertyZip',
		propertyCityInput: '#propertyCity',
		propertyCityDisplay: '#propertyCityDisplay',
		configurationSubmit: '#configurationSubmit',
		groundReportInfoStep1: '#groundReportInfoStep1',
		groundReportInfoStep2: '#groundReportInfoStep2',
		activateGroundReportFilesUploadButton: '#activateGroundReportFilesUpload',
		confirmGroundReportFilesUpload: '#confirmGroundReportFilesUpload',
		cancelGroundReportFilesUpload: '.cancelGroundReportFilesUpload',
		groundReportFilesUploadHidden: '#groundReportFilesUpload',
		soilTypeSelectionContainer: '#soilTypeSelection',
		soilTypeInputs: '.soilType',
		groundReportFilesUploadNotification: '#groundReportFilesUploadNotification',
		clientTypeSelect: '#clientTypes',
		companyInput: '#clientCompany',
		changeWeatherStation: '#changeWeatherStation',
		weatherStationZip: '#weatherStationZip',
		confirmManualWeatherStationSelection: '#confirmManualWeatherStationSelection',
		grafPartnerRow: '.row.graf-partner',
		grafPartnerCheckbox: '#hasGrafPartner',
		grafPartnerInput: '#clientGrafPartner > input',
		attenuationPlusRow: '.row.attenuationPlus',
		attenuationPlusCheckbox: 'input.attenuationPlusCheckbox',
		permittedDischargeInput: '#permittedDischarge',
		permittedDischargeUnitInput: '#permittedDischargeUnit',
		rainDrainageInput: '#rainDrainage',
		rainDrainageAreaInput: '#area',
		permittedDischargeError: '#permittedDischargeError',
		ignorePermittedDischargeCheckbox: '#ignorePermittedDischarge',
		rainFrequencySelect: '#rainFrequency',
		groundwaterDistance: '#groundwaterDistance',
		availableLength: '#availableLength',
		availableWidth: '#availableWidth',
		channelConnectionHeight: '#channelConnectionHeight',
		progressButton: '.progress-button',
		backButton: '.progress-back-button',
		progressMeter: '#progress-bar .meter',
		inquiryIntro: '#inquiry-intro',
		startCalculatorButton: '#start-calculator',
		calculator: '#calculator',
		checkboxRoot: '.checkbox-root',
		checkboxTeaser: '.checkbox-teaser',
		squareCheckbox: '.square-checkbox-container',
		squareCheckboxRoot: '.square-checkbox-root',
		nextSlideScrollTarget: '#next-slide-scroll-target',
		checkboxDescription: '.checkbox-description',
        newGuidelineRadios: '.newGuideline',
		legacyGuidelineRadio: '#newGuideline0',
		newGuidelineRadio: '#newGuideline1',
	},

	values: {
		infiltrationType: {
			RIGOLE: 1,
			TROUGH_RIGOLE: 2,
			RETENTION_CISTERN: 3
		},
		customerTypes: {
			END_CUSTOMER: 1,
			PROCESSORS: 2
		},
		countries: {
			GERMANY: 1,
			AUSTRIA: 2,
			SWITZERLAND: 3,
			BELGIUM: 4,
			NETHERLANDS: 5,
			LUXEMBOURG: 6
		}
	},

	// CHANGE: Centralized UI/configuration constants for the form
	// Keep defaults here so managers/host can consume a single source of truth.
	settings: {
		// Maximum number of area rows allowed (used by both legacy 138 and new 138-1 managers)
		areaTypeMax: 14,
		// Step for coefficient/Cm/Cs dropdowns; negative value means count downwards
		coefficientStep: -0.05
	}
};

export default FormConfig;
